module.exports = __webpack_public_path__ + "static/bg.e366a78e.png";